import { tns } from '@paybis/tiny-slider/src/tiny-slider';
import { getLocaleDirection } from '../helpers/helper';

document.addEventListener('DOMContentLoaded', () => {
  tns({
    container: '.carousel .VueCarousel',
    autoplay: true,
    items: 1,
    slideBy: 1,
    nav: true,
    navPosition: 'bottom',
    controls: true,
    controlsContainer: false,
    textDirection: getLocaleDirection(),
    loop: false,
    responsive: {
      1000: {
        items: 3,
        slideBy: 3,
      },
      768: {
        items: 2,
        slideBy: 2,
      },
    },
  });
});
